import apiClient from "@/shared/api/apiClientPayments";

export const createInvoice = async (payload) => {
  const { data } = await apiClient.post("/invoices", payload);
  return data;
};

export const getInvoice = async (uuid) => {
  const { data } = await apiClient.get(`/invoices/${uuid}`);
  return data;
};

export const getInvoices = async (params) => {
  const { data } = await apiClient.get("/invoices", { params });
  return data;
};
